import styled from 'styled-components';
import { unthemed, zIndex } from 'tokens';

interface PrototypeContainerProps {
	backgroundColor: string;
}
export const PrototypeContainer = styled.div<PrototypeContainerProps>`
	flex: 1;
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100%;
	background-color: ${(props) => props.backgroundColor};
`;

interface FrameContainerProps {
	x: number;
	y: number;
	width: number;
	height: number;
	scale: number;
	backgroundColor?: string;
}

export const FrameContainer = styled.div<FrameContainerProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	transform: scale(${(props) => props.scale});
	transform-origin: top left;
	background: ${(p) => p.backgroundColor ?? p.theme.gray[900]};
`;

interface FrameStatusOverlayProps {
	x: number;
	y: number;
	width: number;
	height: number;
	scale: number;
}

export const FrameStatusOverlay = styled.div<FrameStatusOverlayProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: ${(props) => props.width}px;
	height: ${(props) => props.height}px;
	transform: scale(${(props) => props.scale});
	transform-origin: top left;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: ${unthemed.gray[900]}bb;
`;

export const FrameStatusContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const ScaledButton = styled.div<{ scale: number; marginTop: number }>`
	margin-top: ${(props) => props.marginTop}px;
	transform: scale(${(props) => 1 / props.scale});
	transform-origin: center;
`;

interface ResizeHandleProps {
	side: 'left' | 'right';
	x: number;
	y: number;
	height: number;
}

export const ResizeHandle = styled.div<ResizeHandleProps>`
	position: absolute;
	top: ${(props) => props.y}px;
	left: ${(props) => props.x}px;
	width: 4px;
	height: ${(props) => props.height}px;
	background: transparent;
	border-${(props) => props.side}: 1px solid ${({ theme }) => theme.gray[200]};
	cursor: col-resize;
	z-index: ${zIndex.panel};

	&:hover {
		border-${(props) => props.side}: 1px solid ${({ theme }) => theme.gray[400]};
	}
`;
